module.exports = __webpack_public_path__ + "static/logo-ally-4b742a418b1f617dcb5ff9c82300f230.png";